import { NavLink } from "react-router-dom";
import { Home, Wrench, FileText, Tag, Menu } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Accueil", Icon: Home, end: true },
  { to: "/services", label: "Services", Icon: Wrench },
  { to: "/demande", label: "Demande", Icon: FileText, primary: true },
  { to: "/tarifs", label: "Tarifs", Icon: Tag },
  { to: "/contact", label: "Plus", Icon: Menu },
];

export default function MobileTabBar() {
  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-md border-t border-surface-200 grid grid-cols-5 safe-area-pb"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="mobile-tabbar"
    >
      {ITEMS.map(({ to, label, Icon, primary, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-semibold ${
              primary
                ? "text-white"
                : isActive
                ? "text-brand"
                : "text-txt-500"
            }`
          }
          data-testid={`tabbar-${label.toLowerCase()}`}
        >
          {({ isActive }) => (
            <>
              {primary ? (
                <div className="w-11 h-11 -mt-5 bg-brand rounded-full flex items-center justify-center shadow-elevated">
                  <Icon size={20} className="text-white" />
                </div>
              ) : (
                <Icon size={20} className={isActive ? "text-brand" : "text-txt-300"} />
              )}
              <span className={primary ? "text-brand font-bold mt-0.5" : ""}>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
